// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Set from "rescript/lib/es6/belt_Set.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactFeather from "react-feather";
import * as Hooks$Coronate from "../Hooks.res.js";
import * as Utils$Coronate from "../Utils.res.js";
import * as Data_Id$Coronate from "../Data/Data_Id.res.js";
import * as Belt_MutableQueue from "rescript/lib/es6/belt_MutableQueue.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "../Externals/Externals.res.js";
import * as Data_Player$Coronate from "../Data/Data_Player.res.js";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as PagePlayers$Coronate from "../PagePlayers.res.js";
import VisuallyHidden from "@reach/visually-hidden";

var sortFirstName = {
  TAG: "GetString",
  _0: (function (p) {
      return p.firstName;
    })
};

var sortLastName = {
  TAG: "GetString",
  _0: (function (p) {
      return p.lastName;
    })
};

function PageTourneyPlayers$Selecting(props) {
  var tourney = props.tourney;
  var playerIds = tourney.playerIds;
  var players = props.players;
  var setTourney = props.setTourney;
  var match = Hooks$Coronate.useSortedTable(Belt_Map.valuesToArray(players), sortFirstName, false);
  var tableDispatch = match[1];
  var table = match[0];
  var togglePlayer = function ($$event) {
    var id = $$event.target.value;
    if ($$event.target.checked) {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: Belt_Set.add(playerIds, id),
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: tourney.roundList
                });
    } else {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: Belt_Set.keep(playerIds, (function (pId) {
                          return !Data_Id$Coronate.eq(pId, id);
                        })),
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: tourney.roundList
                });
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Select all",
                              className: "button-micro",
                              onClick: (function (param) {
                                  setTourney({
                                        id: tourney.id,
                                        name: tourney.name,
                                        date: tourney.date,
                                        playerIds: Belt_Set.fromArray(Belt_Map.keysToArray(players), Data_Id$Coronate.id),
                                        scoreAdjustments: tourney.scoreAdjustments,
                                        byeQueue: tourney.byeQueue,
                                        tieBreaks: tourney.tieBreaks,
                                        roundList: tourney.roundList
                                      });
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Select none",
                              className: "button-micro",
                              onClick: (function (param) {
                                  setTourney({
                                        id: tourney.id,
                                        name: tourney.name,
                                        date: tourney.date,
                                        playerIds: Belt_Set.make(Data_Id$Coronate.id),
                                        scoreAdjustments: tourney.scoreAdjustments,
                                        byeQueue: tourney.byeQueue,
                                        tieBreaks: tourney.tieBreaks,
                                        roundList: tourney.roundList
                                      });
                                })
                            })
                      ],
                      className: "toolbar"
                    }),
                JsxRuntime.jsxs("table", {
                      children: [
                        JsxRuntime.jsx("caption", {
                              children: "Select players"
                            }),
                        JsxRuntime.jsx("thead", {
                              children: JsxRuntime.jsxs("tr", {
                                    children: [
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "First name",
                                                  sortColumn: sortFirstName,
                                                  data: table,
                                                  dispatch: tableDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "Last name",
                                                  sortColumn: sortLastName,
                                                  data: table,
                                                  dispatch: tableDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: "Select"
                                          })
                                    ]
                                  })
                            }),
                        JsxRuntime.jsx("tbody", {
                              children: Belt_Array.map(table.table, (function (param) {
                                      var lastName = param.lastName;
                                      var id = param.id;
                                      var firstName = param.firstName;
                                      return JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("td", {
                                                          children: firstName
                                                        }),
                                                    JsxRuntime.jsx("td", {
                                                          children: lastName
                                                        }),
                                                    JsxRuntime.jsxs("td", {
                                                          children: [
                                                            JsxRuntime.jsx(VisuallyHidden, {
                                                                  children: JsxRuntime.jsx("label", {
                                                                        children: "Select " + firstName + " " + lastName,
                                                                        htmlFor: "select-" + Data_Id$Coronate.toString(id)
                                                                      })
                                                                }),
                                                            JsxRuntime.jsx("input", {
                                                                  id: "select-" + Data_Id$Coronate.toString(id),
                                                                  checked: Belt_Set.has(playerIds, id),
                                                                  type: "checkbox",
                                                                  value: Data_Id$Coronate.toString(id),
                                                                  onChange: togglePlayer
                                                                })
                                                          ]
                                                        })
                                                  ]
                                                }, Data_Id$Coronate.toString(id));
                                    }))
                            })
                      ]
                    }),
                JsxRuntime.jsx(PagePlayers$Coronate.NewPlayerForm.make, {
                      dispatch: props.playersDispatch,
                      addPlayerCallback: (function (id) {
                          setTourney({
                                id: tourney.id,
                                name: tourney.name,
                                date: tourney.date,
                                playerIds: Belt_Set.add(playerIds, id),
                                scoreAdjustments: tourney.scoreAdjustments,
                                byeQueue: tourney.byeQueue,
                                tieBreaks: tourney.tieBreaks,
                                roundList: tourney.roundList
                              });
                        })
                    })
              ]
            });
}

var Selecting = {
  make: PageTourneyPlayers$Selecting
};

function hasHadBye(matches, playerId) {
  return Belt_Array.some(Belt_Array.keep(Belt_MutableQueue.toArray(matches), (function (match) {
                    if (Data_Id$Coronate.eq(match.whiteId, playerId)) {
                      return true;
                    } else {
                      return Data_Id$Coronate.eq(match.blackId, playerId);
                    }
                  })), (function (match) {
                if (Data_Id$Coronate.isDummy(match.whiteId)) {
                  return true;
                } else {
                  return Data_Id$Coronate.isDummy(match.blackId);
                }
              }));
}

function errorNotification(x) {
  if (x !== undefined && x.TAG !== "Ok") {
    return JsxRuntime.jsx(Utils$Coronate.$$Notification.make, {
                children: x._0,
                kind: "Error"
              });
  } else {
    return null;
  }
}

var initial = {
  scoreAdjustment: "Pristine"
};

function scoreAdjustment(scoreAdjustment$1) {
  var x = Belt_Float.fromString(scoreAdjustment$1);
  if (x !== undefined) {
    return {
            TAG: "Ok",
            _0: x
          };
  } else {
    return {
            TAG: "Error",
            _0: "Score adjustment must be a number."
          };
  }
}

function validateForm(param) {
  var result = param.fieldStatuses.scoreAdjustment;
  var scoreAdjustmentResult;
  scoreAdjustmentResult = typeof result !== "object" ? scoreAdjustment(param.input.scoreAdjustment) : result._0;
  if (scoreAdjustmentResult.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              scoreAdjustment: scoreAdjustmentResult._0
            },
            fieldStatuses: {
              scoreAdjustment: {
                TAG: "Dirty",
                _0: scoreAdjustmentResult
              }
            }
          };
  } else {
    return {
            TAG: "Invalid",
            fieldStatuses: {
              scoreAdjustment: {
                TAG: "Dirty",
                _0: scoreAdjustmentResult
              }
            }
          };
  }
}

function useForm(initialInput) {
  var memoizedInitialState = React.useMemo((function () {
          return {
                  input: initialInput,
                  fieldStatuses: initial,
                  formStatus: "Editing"
                };
        }), [initialInput]);
  var match = React.useReducer((function (state, action) {
          if (typeof action !== "object") {
            if (action !== "BlurScoreAdjustmentField") {
              return {
                      input: initialInput,
                      fieldStatuses: initial,
                      formStatus: "Editing"
                    };
            }
            var result = Utils$Coronate.FormHelper.validateFieldOnBlurWithValidator(state.input.scoreAdjustment, state.fieldStatuses.scoreAdjustment, scoreAdjustment);
            if (result !== undefined) {
              return {
                      input: state.input,
                      fieldStatuses: {
                        scoreAdjustment: result
                      },
                      formStatus: state.formStatus
                    };
            } else {
              return state;
            }
          } else {
            if (action.TAG === "UpdateScoreAdjustmentField") {
              var nextValue = action._0;
              return {
                      input: {
                        scoreAdjustment: nextValue
                      },
                      fieldStatuses: {
                        scoreAdjustment: {
                          TAG: "Dirty",
                          _0: scoreAdjustment(nextValue)
                        }
                      },
                      formStatus: state.formStatus
                    };
            }
            var match = state.formStatus;
            if (typeof match === "object") {
              return state;
            }
            var match$1 = validateForm(state);
            if (match$1.TAG === "Valid") {
              return {
                      input: state.input,
                      fieldStatuses: match$1.fieldStatuses,
                      formStatus: {
                        TAG: "Submitting",
                        _0: match$1.output,
                        _1: action._0
                      }
                    };
            } else {
              return {
                      input: state.input,
                      fieldStatuses: match$1.fieldStatuses,
                      formStatus: "Editing"
                    };
            }
          }
        }), memoizedInitialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          var match = state.formStatus;
          if (typeof match === "object") {
            match._1(match._0);
            dispatch("Reset");
          }
          
        }), [state.formStatus]);
  return {
          state: state,
          dispatch: dispatch
        };
}

function updateScoreAdjustment(param, nextValue) {
  param.dispatch({
        TAG: "UpdateScoreAdjustmentField",
        _0: nextValue
      });
}

function scoreAdjustmentResult(param) {
  return Utils$Coronate.FormHelper.exposeFieldResult(param.state.fieldStatuses.scoreAdjustment);
}

function input(param) {
  return param.state.input;
}

function valid(param) {
  var match = validateForm(param.state);
  if (match.TAG === "Valid") {
    return true;
  } else {
    return false;
  }
}

function submitting(param) {
  var match = param.state.formStatus;
  if (typeof match !== "object") {
    return false;
  } else {
    return true;
  }
}

function PageTourneyPlayers$OptionsForm$More(props) {
  var p = props.p;
  var tourney = props.tourney;
  var dialog = props.dialog;
  var setTourney = props.setTourney;
  var scoreAdjustment = Belt_Option.mapWithDefault(Belt_Map.get(tourney.scoreAdjustments, p.id), "0", (function (prim) {
          return String(prim);
        }));
  var form = useForm({
        scoreAdjustment: scoreAdjustment
      });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("button", {
                      children: "close",
                      className: "button-micro button-primary",
                      onClick: (function (param) {
                          dialog.setFalse();
                        })
                    }),
                JsxRuntime.jsx("h2", {
                      children: "Options for " + Data_Player$Coronate.fullName(p)
                    }),
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: JsxRuntime.jsx("label", {
                                    children: "Score adjustment",
                                    className: "title-30",
                                    htmlFor: Data_Id$Coronate.toString(p.id) + "-scoreAdjustment"
                                  })
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Score adjustment will be added to this player's actual score.\n              It can be negative.",
                              className: "caption-30",
                              id: Data_Id$Coronate.toString(p.id) + "-scoreAdjustment-description"
                            }),
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsx("input", {
                                      "aria-describedby": Data_Id$Coronate.toString(p.id) + "-scoreAdjustment-description",
                                      id: Data_Id$Coronate.toString(p.id) + "-scoreAdjustment",
                                      disabled: submitting(form),
                                      size: 3,
                                      step: 0.5,
                                      type: "number",
                                      value: input(form).scoreAdjustment,
                                      onBlur: (function (param) {
                                          form.dispatch("BlurScoreAdjustmentField");
                                        }),
                                      onChange: (function ($$event) {
                                          updateScoreAdjustment(form, $$event.target.value);
                                        })
                                    }),
                                " ",
                                JsxRuntime.jsx("button", {
                                      children: "Reset",
                                      className: "button-micro",
                                      onClick: (function ($$event) {
                                          $$event.preventDefault();
                                          updateScoreAdjustment(form, "0");
                                        })
                                    })
                              ]
                            }),
                        errorNotification(scoreAdjustmentResult(form)),
                        JsxRuntime.jsx("p", {
                              children: JsxRuntime.jsx("input", {
                                    disabled: submitting(form) || !valid(form),
                                    type: "submit",
                                    value: "Save"
                                  })
                            })
                      ],
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          var fn = function (output) {
                            var scoreAdjustment = output.scoreAdjustment;
                            if (scoreAdjustment !== 0) {
                              setTourney({
                                    id: tourney.id,
                                    name: tourney.name,
                                    date: tourney.date,
                                    playerIds: tourney.playerIds,
                                    scoreAdjustments: Belt_Map.set(tourney.scoreAdjustments, p.id, scoreAdjustment),
                                    byeQueue: tourney.byeQueue,
                                    tieBreaks: tourney.tieBreaks,
                                    roundList: tourney.roundList
                                  });
                            } else {
                              setTourney({
                                    id: tourney.id,
                                    name: tourney.name,
                                    date: tourney.date,
                                    playerIds: tourney.playerIds,
                                    scoreAdjustments: Belt_Map.remove(tourney.scoreAdjustments, p.id),
                                    byeQueue: tourney.byeQueue,
                                    tieBreaks: tourney.tieBreaks,
                                    roundList: tourney.roundList
                                  });
                            }
                            dialog.setFalse();
                          };
                          form.dispatch({
                                TAG: "Submit",
                                _0: fn
                              });
                        })
                    })
              ]
            });
}

function PageTourneyPlayers$OptionsForm(props) {
  var p = props.p;
  var byeQueue = props.byeQueue;
  var tourney = props.tourney;
  var setTourney = props.setTourney;
  var dialog = Hooks$Coronate.useBool(false);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("button", {
                      children: "Bye signup",
                      className: "button-micro",
                      disabled: byeQueue.includes(p.id),
                      onClick: (function (param) {
                          setTourney({
                                id: tourney.id,
                                name: tourney.name,
                                date: tourney.date,
                                playerIds: tourney.playerIds,
                                scoreAdjustments: tourney.scoreAdjustments,
                                byeQueue: Belt_Array.concat(byeQueue, [p.id]),
                                tieBreaks: tourney.tieBreaks,
                                roundList: tourney.roundList
                              });
                        })
                    }),
                " ",
                JsxRuntime.jsxs("button", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: JsxRuntime.jsx(ReactFeather.MoreHorizontal, {}),
                              "aria-hidden": true
                            }),
                        JsxRuntime.jsx(VisuallyHidden, {
                              children: "More options for " + Data_Player$Coronate.fullName(p)
                            })
                      ],
                      className: "button-micro",
                      onClick: (function (param) {
                          dialog.setTrue();
                        })
                    }),
                JsxRuntime.jsx(Externals$Coronate.Dialog.make, {
                      isOpen: dialog.state,
                      onDismiss: dialog.setFalse,
                      ariaLabel: "Options for " + Data_Player$Coronate.fullName(p),
                      children: JsxRuntime.jsx(PageTourneyPlayers$OptionsForm$More, {
                            setTourney: setTourney,
                            dialog: dialog,
                            tourney: tourney,
                            p: p
                          }),
                      className: ""
                    })
              ]
            });
}

function PageTourneyPlayers$PlayerList(props) {
  var byeQueue = props.byeQueue;
  var setTourney = props.setTourney;
  var tourney = props.tourney;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(Belt_Array.map(props.players, (function (p) {
                          return JsxRuntime.jsxs("tr", {
                                      children: [
                                        JsxRuntime.jsx("td", {
                                              children: p.firstName
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: p.lastName
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: JsxRuntime.jsx(PageTourneyPlayers$OptionsForm, {
                                                    setTourney: setTourney,
                                                    tourney: tourney,
                                                    byeQueue: byeQueue,
                                                    p: p
                                                  })
                                            })
                                      ],
                                      className: "player " + Data_Player$Coronate.Type.toString(p.type_)
                                    }, Data_Id$Coronate.toString(p.id));
                        })))
            });
}

function PageTourneyPlayers(props) {
  var tournament = props.tournament;
  var setTourney = tournament.setTourney;
  var tourney = tournament.tourney;
  var getPlayer = tournament.getPlayer;
  var match = Hooks$Coronate.useSortedTable(Belt_Map.valuesToArray(tournament.activePlayers), sortFirstName, false);
  var byeQueue = tourney.byeQueue;
  var playerIds = tourney.playerIds;
  var tableDispatch = match[1];
  var playerTable = match[0];
  var match$1 = React.useState(function () {
        return Belt_Set.isEmpty(playerIds);
      });
  var setIsSelecting = match$1[1];
  var matches = Data_Rounds$Coronate.rounds2Matches(tourney.roundList);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx(ReactFeather.Edit, {}),
                              " Edit player roster"
                            ],
                            onClick: (function (param) {
                                setIsSelecting(function (param) {
                                      return true;
                                    });
                              })
                          }),
                      className: "toolbar"
                    }),
                JsxRuntime.jsxs(Utils$Coronate.PanelContainer.make, {
                      children: [
                        JsxRuntime.jsx(Utils$Coronate.Panel.make, {
                              children: JsxRuntime.jsxs("table", {
                                    children: [
                                      JsxRuntime.jsx("caption", {
                                            children: "Current roster"
                                          }),
                                      JsxRuntime.jsx("thead", {
                                            children: JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                                children: "First name",
                                                                sortColumn: sortFirstName,
                                                                data: playerTable,
                                                                dispatch: tableDispatch
                                                              })
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                                children: "Last name",
                                                                sortColumn: sortLastName,
                                                                data: playerTable,
                                                                dispatch: tableDispatch
                                                              })
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: "Options"
                                                        })
                                                  ]
                                                })
                                          }),
                                      JsxRuntime.jsx("tbody", {
                                            children: JsxRuntime.jsx(PageTourneyPlayers$PlayerList, {
                                                  players: playerTable.table,
                                                  tourney: tourney,
                                                  setTourney: setTourney,
                                                  byeQueue: byeQueue
                                                }),
                                            className: "content"
                                          })
                                    ]
                                  }),
                              style: {
                                flexShrink: "0"
                              }
                            }),
                        JsxRuntime.jsxs(Utils$Coronate.Panel.make, {
                              children: [
                                JsxRuntime.jsx("h3", {
                                      children: "Bye queue"
                                    }),
                                byeQueue.length !== 0 ? JsxRuntime.jsx("table", {
                                        children: JsxRuntime.jsx("tbody", {
                                              children: Belt_Array.map(byeQueue, (function (pId) {
                                                      return JsxRuntime.jsxs("tr", {
                                                                  children: [
                                                                    JsxRuntime.jsx("td", {
                                                                          children: Data_Player$Coronate.fullName(getPlayer(pId))
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("button", {
                                                                                children: "Remove",
                                                                                className: "button-micro",
                                                                                onClick: (function (param) {
                                                                                    setTourney({
                                                                                          id: tourney.id,
                                                                                          name: tourney.name,
                                                                                          date: tourney.date,
                                                                                          playerIds: tourney.playerIds,
                                                                                          scoreAdjustments: tourney.scoreAdjustments,
                                                                                          byeQueue: byeQueue.filter(function (id) {
                                                                                                return !Data_Id$Coronate.eq(pId, id);
                                                                                              }),
                                                                                          tieBreaks: tourney.tieBreaks,
                                                                                          roundList: tourney.roundList
                                                                                        });
                                                                                  })
                                                                              })
                                                                        })
                                                                  ],
                                                                  className: hasHadBye(matches, pId) ? "disabled" : ""
                                                                }, Data_Id$Coronate.toString(pId));
                                                    }))
                                            }),
                                        style: {
                                          width: "100%"
                                        }
                                      }) : JsxRuntime.jsx("p", {
                                        children: "No one has signed up yet.",
                                        className: "caption-20"
                                      })
                              ]
                            }),
                        JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
                              isOpen: match$1[0],
                              onDismiss: (function () {
                                  setIsSelecting(function (param) {
                                        return false;
                                      });
                                }),
                              ariaLabel: "Select players",
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "Done",
                                      className: "button-micro button-primary",
                                      onClick: (function (param) {
                                          setIsSelecting(function (param) {
                                                return false;
                                              });
                                        })
                                    }),
                                JsxRuntime.jsx(PageTourneyPlayers$Selecting, {
                                      tourney: tourney,
                                      setTourney: setTourney,
                                      players: tournament.players,
                                      playersDispatch: tournament.playersDispatch
                                    })
                              ],
                              className: ""
                            })
                      ]
                    })
              ],
              className: "content-area"
            });
}

var make = PageTourneyPlayers;

export {
  Selecting ,
  make ,
}
/* react Not a pure module */
